const appUrls = {
  countriesListForPhoneNumberUrl: `/api/countries-for-phone-number`,
  countriesListUrl: `/api/countries?search=`
};
const portalUrls = {
  profileSubUrl: "/api/profile",
  educationDetailSubUrl: "/api/education/",
  educationDetailsSubUrl:"/api/educations",
  testScoresSubUrl: "/api/tests",
  degreeLevelsSubUrl: "/api/degree-levels"

}

export { appUrls,portalUrls };
